<template>
  <ConfigProvider
    :locale="zhCN"
    :theme="{
      token: {
        fontFamily: '\'Helvetica Neue\', Helvetica, \'PingFang SC\', \'Hiragino Sans GB\', \'Microsoft YaHei\', 微软雅黑, Arial, sans-serif',
      },
    }"
  >
    <router-view />
  </ConfigProvider>
</template>

<script>
  import { ConfigProvider } from 'ant-design-vue'
  import zhCN from 'ant-design-vue/es/locale/zh_CN'
  import { useStore } from 'vuex'
  import dayjs from 'dayjs'
  import 'dayjs/locale/zh-cn'
  import { isNull } from '@/utils'
  dayjs.locale('zh-cn')

  export default {
    name: 'App',
    components: { ConfigProvider },
    data() {
      return {
        zhCN,
      }
    },
    setup() {
      const store = useStore()
      const setTestUserId = async (id) => {
        await store.dispatch('user/setUserId', id)
      }

      return {
        setTestUserId,
      }
    },
    mounted() {
      window.vue = this

      // 从隐藏菜单的页面打开新页面时，新页面也隐藏菜单
      window.open = (function (nativeOpen) {
        return function (desUrl, windowName, windowFeatures) {
          if (isNull(desUrl)) {
            return nativeOpen(desUrl, windowName, windowFeatures)
          }

          // 如果已经有隐藏菜单参数，那么不进行处理
          if (desUrl.indexOf('__hidden=1') !== -1 && desUrl.indexOf('hidden=1') !== -1) {
            return nativeOpen(desUrl, windowName, windowFeatures)
          }

          // 获取当前URL的查询参数，是否需要加上异常菜单参数
          var srcUrl = window.location.search
          var refererUrlParams = new URLSearchParams(desUrl)
          // 存在绕过参数，不进行处理
          if (desUrl.indexOf('no_hidden=1') > -1) {
            // 移除多余参数
            desUrl = desUrl.replace(/[?&]no_hidden=1/g, '')
          } else if (srcUrl.indexOf('__hidden=1') !== -1 || srcUrl.indexOf('hidden=1') !== -1) {
            // 根据当前路由，以及将要跳转的路由，判断是否带上隐藏菜单参数
            if (desUrl.indexOf('__hidden=1') === -1) {
              refererUrlParams.set('__hidden', '1')
            }
            if (desUrl.indexOf('hidden=1') === -1) {
              refererUrlParams.set('hidden', '1')
            }
            desUrl = refererUrlParams.toString()
            desUrl = decodeURIComponent(desUrl)

            // url没有任何参数时，url.set会错误设置=&作为最开始的连接符
            if (desUrl.indexOf('=&__hidden') !== -1) {
              desUrl = desUrl.replace('=&__hidden', '?__hidden')
            } else if (desUrl.indexOf('=&hidden') !== -1) {
              desUrl = desUrl.replace('=&hidden', '?hidden')
            }
          }

          // 加上隐藏参数后，调用原始的 window.open 方法
          return nativeOpen(desUrl, windowName, windowFeatures)
        }
      })(window.open)
    },
  }
</script>
